<header class="fixed w-full z-3 shadow-2">
    <div class="w-full bg-white">
        <div class="flex flex-row justify-content-between align-items-center h-5rem header w-10 m-auto">
            <div class="flex flex-wrap align-items-center">
                <a [routerLink]="url['home']" class="main-logo" title="Inicio">
                    <img ngSrc="assets/images/main-logo.png" width="247" height="50" alt="Logo de MuyComplacientes" />
                </a>
                <a *ngFor="let city of cities" [routerLink]="getCityUrl(city.searchName)" 
                    class="p-button hidden md:block mx-1 no-underline" title="Escorts {{ city.name }}">
                    {{ city.name }}
                </a>
                <div *ngIf="menuItems.length > 0">
                    <a *ngFor="let menuItem of menuItems[2].items" href="{{menuItem.routerLink}}" title="{{menuItem.title}}"></a>
                </div>
            </div>
            <div class="flex gap-1">
                <a [routerLink]="getUrl('registro-1')" *ngIf="!isUserLogged" class="p-button hidden md:block no-underline" title="Crear anuncio">
                    Crear perfil
                </a>
                <a [routerLink]="getUrl('login')" *ngIf="!isUserLogged" class="p-button hidden md:block no-underline" title="Iniciar sesión">
                    Iniciar sesión
                </a>
                <p-button class="hidden md:block" *ngIf="isUserLogged" (click)="visibleMenu = true">
                    Opciones
                </p-button>
                <p-button class="block md:hidden" *ngIf="isUserLogged" styleClass="border-transparent" (click)="visibleMenu = true" ariaLabel="Menú principal">
                    <i class="pi pi-bars" style="font-size: 1.4rem;"></i>
                </p-button>
                <p-button *ngIf="!isUserLogged" styleClass="border-transparent" (click)="visibleMenu = true" ariaLabel="Menú principal">
                    <i class="pi pi-bars" style="font-size: 1.4rem;"></i>
                </p-button>
            </div>
        </div>
    </div>
    <p-sidebar [(visible)]="visibleMenu" position="right" appendTo="body" [blockScroll]="true">
        <ng-template pTemplate="header">
            <p>MuyComplacientes</p>
        </ng-template>
        <ng-template pTemplate="content">
            <p-menu #menu [model]="menuItems" styleClass="w-full border-none"></p-menu>
        </ng-template>
    </p-sidebar>
    <p-dialog header="Header" [(visible)]="showDialog" [modal]="true" styleClass="md:w-7 w-10" [draggable]="false" 
        [resizable]="false" [closable]="false" aria-label="Dialogo para asegurar mayoría de edad" aria-labelledby="disclaimer-text">
        <ng-template pTemplate="header">
            <p id="disclaimer-text" class="font-medium">Este sitio web es sólo para mayores de 18 años. Al ingresar estás aceptando los 
                <a class="link" [routerLink]="url['terminos']">Términos y Condiciones y Política de Privacidad</a>
            </p>
        </ng-template>
        <div class="flex flex-row flex-wrap justify-content-evenly">
            <p-button (onClick)="getIn()" styleClass="m-3">Entrar</p-button>
        </div>
    </p-dialog>
</header>